import "../css/card_design.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TopBarLogin from './TopBarLogin';
import { Oval } from "react-loader-spinner";
import { useState } from 'react';
import logo from '../images/logo.jpeg';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import ForgotpasswordOTP from "./ForgotpasswordOTP";



function Forgotpassword() {

    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    var location = useLocation();

    const navigation = useNavigate()

    function validation() {
        let isValid = true;

        if (!email.trim()) {
            setEmailError("Please enter your registered Email");
            isValid = false;
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
        ) {
            setEmailError("Please enter a valid Email address");
            isValid = false;
        } else {
            setEmailError("");
        }

        return isValid;
    }

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    function ForgotpasswordAPICall(email) {

        setIsLoading(true);
        console.log("Response:", "response.data");
        axios.get(
            ApiConfig.getUrl("User/forgot_password"),
            {
                params: {
                    username: email
                },
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {
                console.log("Response:", response.data);
                const api = ApiResponse.fromJson(response.data);
                setIsLoading(false)

                if (api.statusCode == 200) {
                    // if (api.response == 1) {

                    showToast(api.message);

                    navigation('/ForgotpasswordOTP', {
                        state: {
                            userId: api.response.user_Id,
                            isFromRegistration: false,
                            isFromForgot: true
                        }
                    });
                    //}
                } else if (api.response == 1) {
                    showToastFailed(api.errorMessage);
                }
                else{
                     showToastFailed(api.errorMessage);
                }
            })
    }

    const disableRightClick = (e) => {
        e.preventDefault();
    };

    return (
        <div className="fullview" onContextMenu={disableRightClick}>
            <TopBarLogin />
            <ToastContainer />
            {isLoading && (
                <div className="loader-overlay">
                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />
                </div>
            )}
            <div className='container'>

                <div className='row mt-5 align-items-center gx-0'>
                    <div className="col-lg-5 col-12  p-4 d-flex justify-content-center align-items-center mt-3">
                        <img className='image h-100 w-100' src={logo} alt='logo' />
                    </div>

                    <div className="col-lg-6 col-12 card  p-3">
                        <p className="h5 text-center mt-2 pt-2">Forgotpassword</p>

                        <label htmlFor="email">Email</label>

                        <input
                            type="text"
                            id="email"
                            placeholder="Registered Email"
                            className="form-control mb-2"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setEmailError("");
                            }}
                        />

                        <span className="text-danger  text-decoration-none">{emailError}</span>

                        <button
                            onClick={() => {
                                if (validation()) {
                                    ForgotpasswordAPICall(email);
                                }
                            }}
                            type="button"
                            className="btn  w-100 mt-4 text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}
                        >
                            Submit
                        </button>


                    </div>
                </div>
            </div>



            {/* <div className="card">
                <div >

<label className='h3'>Forgot Password?</label>


<label>Enter Your Registered Email ID and we will<br/> send you a link and OTP to reset your password.</label>
<input  className="input-style" type="text" placeholder="E-mail ID / Mobile No"/>


<button className='send-button'style={{borderRadius:"10px"}}>CONTINUE</button>
</div>
</div> */}

        </div>
    );
}
export default Forgotpassword;